angular.module('ib-MmB-communication-lost-module', []);
